interface ComparisonRowProps {
  label: string
  valueA: number | string | null
  valueB: number | string | null
  format?: "number" | "currency" | "text"
  higherIsBetter?: boolean
}

function formatValue(
  value: number | string | null,
  format: "number" | "currency" | "text"
): string {
  if (value === null || value === undefined) return "N/A"

  if (format === "currency" && typeof value === "number") {
    return `\u00A3${value.toLocaleString()}`
  }

  if (format === "number" && typeof value === "number") {
    return value.toLocaleString()
  }

  return String(value)
}

function getWinner(
  a: number | string | null,
  b: number | string | null,
  higherIsBetter: boolean
): "a" | "b" | "tie" {
  if (a === null || b === null) return "tie"
  if (typeof a !== "number" || typeof b !== "number") return "tie"
  if (a === b) return "tie"

  if (higherIsBetter) {
    return a > b ? "a" : "b"
  }
  return a < b ? "a" : "b"
}

export default function ComparisonRow({
  label,
  valueA,
  valueB,
  format = "text",
  higherIsBetter = true,
}: ComparisonRowProps) {
  const winner = getWinner(valueA, valueB, higherIsBetter)

  const aStyle =
    winner === "a" ? "font-bold text-charcoal" : "text-slate"
  const bStyle =
    winner === "b" ? "font-bold text-charcoal" : "text-slate"

  return (
    <div className="grid grid-cols-3 items-center gap-4 py-2">
      <span className={`text-right text-sm ${aStyle}`}>
        {formatValue(valueA, format)}
      </span>
      <span className="text-center text-xs font-medium uppercase tracking-[0.15em] text-slate">
        {label}
      </span>
      <span className={`text-left text-sm ${bStyle}`}>
        {formatValue(valueB, format)}
      </span>
    </div>
  )
}
